// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"28":"novedades","273":"habitualist","404":"usuarios","588":"circulares","757":"not-found"}[chunkId] || chunkId) + "." + {"28":"33441104","196":"8c742366","213":"c62b165c","273":"4d05cb5e","404":"c93ff942","522":"5c9ac861","588":"0af36eed","757":"9bc50b29"}[chunkId] + ".css";
};